import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { fadeInLeft } from "react-animations";
import { primaryColor, primaryColorHover } from "../../../../config/constants";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInLeft}`;
// Styles
export const SessionMainDiv = styled.div`
  margin: 0 auto 10px;
  max-width: 860px;
  @media (max-width: 910px) {
    margin: 0 auto 10px;
    width: 85%;
  }
`;
export const SessionDiv = styled.div`
  height: 50px;
  width: fit-content;
  display: flex;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    height: auto;
    flex-direction: column;
    box-shadow: none;
    background: transparent;
    transition: all 0.5s ease-out;
  }
`;
export const InfoDiv = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 910px) {
    width: 270px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-out;
  }
`;
export const SessionText = styled.p`
  width: ${({ width }) => width && width};
  font-size: 14px;
  text-align: center;
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
    font-size: 12px;
  }
`;
export const ShowExtraInfoButton = styled.button`
  width: 35px;
  height: 80%;
  display: none;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid #ccc;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const ShowExtraInfoImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const ExtraInfoDiv = styled.div`
  width: auto;
  height: 50px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  @media (max-width: 910px) {
    margin-top: 2px;
    padding: 0 0 0 10px;
    width: ${({ distanceLeft }) => (distanceLeft ? "350px" : "270px")};
    height: 60px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    display: ${({ show }) => (show ? "flex" : "none")};
    justify-content: space-between;
    animation: 0.5s ${fadeInDownAnimation};
  }
`;
export const ExtraInfoSessionDiv = styled.div`
  padding: 5px 0 7px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 5px 5px 0;
  @media (max-width: 910px) {
    height: 95%;
  }
`;
export const ExtraInfoSessionTitle = styled.p`
  display: none;
  font-size: 12px;
  font-weight: 600;
  color: #808080;
  @media (max-width: 910px) {
    display: inline;
  }
`;
export const DetailsDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  justify-content: center;
  @media (max-width: 910px) {
    width: auto;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
`;
export const DetailsLink = styled(Link)`
  width: 35px;
  height: 35px;
  background-color: ${primaryColor};
  border-radius: 5px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
  @media (max-width: 910px) {
    width: 25px;
    height: 25px;
  }
`;
export const DetailsImg = styled.img`
  width: 70%;
  height: 70%;
`;
export const DeleteSessionButton = styled.button`
  width: 50px;
  height: 100%;
  background: transparent;
  outline: none;
  border: none;
  border-left: 2px solid #ccc;
  cursor: pointer;
  @media (max-width: 910px) {
    width: 35px;
  }
`;
export const DeleteSessionImg = styled.img`
  width: 20px;
  height: 20px;
`;
